import setCurrentPage from "src/Utils/setCurrentPage";

const cards: CardDemoProps[] = [
  {
    image: "INTRO/empty.png",
    imageStyle: { maxHeight: "50px" },
    title: "Intelligent Networks of the future",
    text: "Smart solutions enabled by Open Digital Architecture driving the future intent\ndriven and autonomous networks.",
    choose: {
      label: "View more",
      onClick: () => setCurrentPage("ENG_1"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    image: "INTRO/empty.png",
    imageStyle: { maxHeight: "50px" },
    title: "INFOSYS LIVE\nOPERATIONS",
    text: "A digital solutions designed to help organizations become more agile, resilient, and responsive in real-time.",
    choose: {
      label: "View more",
      onClick: () => setCurrentPage("ILO_2"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    image: "INTRO/topaz.png",
    imageStyle: { maxHeight: "50px" },
    title: "AI-Twin\nfor marketers",
    text: "Your AI partner that transforms marketing with autonomous recommendations, visibility, decisioning, and activation.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("AITWIN_301"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    image: "INTRO/cortex.png",
    imageStyle: { maxHeight: "50px" },
    title: "Customer Services\nTransformation",
    text: "AI-driven customer engagement platform,\ntransforms contact center operations\nthrough purposeful communication and\nsmart decision-making capabilities.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("CORTEX_1"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
];

const data = {
  bgVideo: "videos/INTRO/INTRO.mp4",
  subtitle: "Select a product to  experience the next",
  cards: cards,
  showLines: true,
};

export default data;
